import { render, staticRenderFns } from "./UploadDocument.vue?vue&type=template&id=7ed4185c&scoped=true"
import script from "./UploadDocument.vue?vue&type=script&lang=js"
export * from "./UploadDocument.vue?vue&type=script&lang=js"
import style0 from "./UploadDocument.vue?vue&type=style&index=0&id=7ed4185c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed4185c",
  null
  
)

export default component.exports